import { Validators } from '@angular/forms';

export class ExpensesDetailsModel {
  expensesList = {
    value: [],
    validation: Validators.compose([
      Validators.required
    ])
  };
  totalExpensesValue = {
    value: 0,
    validation: Validators.compose([])
  };
  faDataCheck = {
    value: null,
    validation: Validators.compose([]),
  };
}

export class IndividualExpenseModel {
  type = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  amount = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.pattern('^[0-9\.]*$')
    ])
  };
}
